import axios from 'axios';
import * as Sentry from '@sentry/react';

export const httpClient = axios.create({
  baseURL: window.__ENV__.VITE_API_BASE_URL || import.meta.env.VITE_API_BASE_URL
})

httpClient.interceptors.response.use(
  (res) => res,
  (error: unknown) => {
    if (axios.isAxiosError(error)) {
      Sentry.withScope((scope) => {
        scope.setTag('layer', 'axios');
        scope.setTag('http.method', String(error.config?.method ?? '').toUpperCase());
        scope.setTag('http.status_code', String(error.response?.status ?? ''));
        scope.setContext('http', {
          url: error.config?.url,
          baseURL: error.config?.baseURL,
          method: error.config?.method,
          status: error.response?.status,
        });
        const apiError = (error.response?.data as any)?.error;
        if (typeof apiError === 'string') scope.setExtra('api.error', apiError);

        Sentry.captureException(error);
      });
    } else {
      Sentry.captureException(error as any);
    }

    return Promise.reject(error);
  },
);